import { render } from "./EscortComponent.vue?vue&type=template&id=41679df0&scoped=true"
import script from "./EscortComponent.vue?vue&type=script&lang=js"
export * from "./EscortComponent.vue?vue&type=script&lang=js"

import "./EscortComponent.vue?vue&type=style&index=0&id=41679df0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41679df0"]])

export default __exports__